import { stats } from '@/mocks/siteData';

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-2">
                {stat.value}
                <span className="text-lg md:text-xl text-background-50/70">{stat.suffix}</span>
              </div>
              <p className="text-background-50/75 text-sm md:text-base">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}